import "./App.css";
import Router from "./Routing/Router";


function App() {
  return (
    <div className="App">
      <Router />
    </div>
  );
}

export default App;
